module.exports = __webpack_public_path__ + "static/media/cover.bb7cf27a.png";